import styles from './join-panel.module.scss';

const JoinPanel = (props: any) => {
  const { onClickJoin } = props;
  return (
    <div className={styles.container}>
      <div className={styles.sessionName}>Live Session</div>

      <button className={styles.joinBtn} onClick={onClickJoin}>
        Join
      </button>
    </div>
  );
};

export default JoinPanel;
